<template>
  <v-row
    dense
    class="px-4"
    v-shortkey="['meta', 'k']"
    @shortkey="isSearchOpen = !isSearchOpen"
  >
    <v-col cols="12" class="d-flex">
      <v-row dense justify="end">
        <v-col cols="auto">
          <h2 v-if="title">{{ title }}</h2>
        </v-col>

        <v-spacer />
        <v-col v-if="isSearchable" cols="12" sm="6" class="grow">
          <v-row dense justify="end">
            <v-col cols="12" class="grow">
              <v-row dense justify="end">
                <v-col class="shrink" v-if="isExportable">
                  <AdminOrderCSVexportButton />
                </v-col>
                <v-col :class="{ shrink: !isSearchOpen }">
                  <ManageBaseTableSearchBar
                    v-if="isSearchable"
                    :Model="Model"
                  />
                </v-col>
                <v-col
                  :class="['table-header-sort-wrap', { grow: !isSearchOpen }]"
                >
                  <ManageBaseTableSortMenu :Model="Model" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>

        <v-col v-if="quickLinks" cols="12" class="header-quick-links">
          <v-btn
            plain
            key="All"
            :to="{ path: $route.path }"
            x-small
            exact
            tile
            class="mr-1"
            >All</v-btn
          >
          <v-btn
            v-for="{ title, query } of quickLinks"
            plain
            :to="{ path: `${$route.path}`, query }"
            :key="title"
            tile
            x-small
            exact
            class="mr-1"
            >{{ title }}</v-btn
          >
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { Model } from '@vuex-orm/core'
import _get from 'lodash/get'

import ManageBaseTableSearchBar from '@/components/ManageBaseTableSearchBar'
import ManageBaseTableSortMenu from '@/components/ManageBaseTableSortMenu'
import AdminOrderCSVexportButton from '@/components/AdminOrderCSVexportButton'
export default {
  name: 'ManageBaseTableHeader',
  components: {
    ManageBaseTableSearchBar,
    ManageBaseTableSortMenu,
    AdminOrderCSVexportButton,
  },
  props: {
    title: {
      type: String,
      default: 'Loading...',
    },
    isSearchable: {
      type: Boolean,
      default: true,
    },
    Model: {
      type: Model,
      default: () => Model,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapFields('admin', ['isSearchOpen']),
    quickLinks() {
      let links = _get(this.Model, 'index_quick_links', () => {})
      return links()
    },
    isExportable() {
      let config = _get(this.Model, 'index_table_config', () => {})
      return _get(config(), 'exportable', false)
    }, // isExportable
  },
}
</script>

<style lang="scss">
.header-quick-links {
  .v-btn {
    border-bottom: 2px solid transparent;
    &.v-btn--active {
      color: #1976d2;
      border-bottom-color: #1976d2;
    }
  }
}
.table-header-sort-wrap {
  max-width: 220px;
}
</style>
